import { selector } from "recoil";

import { getProductionDisplayStateFromPollState } from "../../helpers";
import {
  IProductionChainStep,
  IProductionDisplayState,
  IProductionPollState,
} from "../../models";
import { productionPollGroupStateAtom } from "../atoms";

export const productionPollStatesSelector = selector<IProductionPollState[]>({
  key: "productionPollStatesSelector",
  get: ({ get }) => {
    return get(productionPollGroupStateAtom)?.states || [];
  },
});

export const productionPollChainsSelector = selector<IProductionChainStep[]>({
  key: "productionPollChainsSelector",
  get: ({ get }) => {
    return get(productionPollGroupStateAtom)?.chains || [];
  },
});

// poll
export const productionPollIdSelector = selector<number | undefined>({
  key: "productionPollIdSelector",
  get: ({ get }) => {
    return get(productionPollGroupStateAtom)?.productionPollId;
  },
});

export const productionPollStateSelector = selector<
  IProductionPollState | undefined
>({
  key: "productionPollStateSelector",
  get: ({ get }) => {
    const productionPollId = get(productionPollIdSelector);
    const states = get(productionPollStatesSelector);
    return states?.find(s => s.productionId === productionPollId);
  },
});

export const productionPollDisplayStateSelector =
  selector<IProductionDisplayState>({
    key: "productionPollDisplayStateSelector",
    get: ({ get }) => {
      const state = get(productionPollStateSelector);
      return getProductionDisplayStateFromPollState(state);
    },
  });

// ui
export const productionUiIdSelector = selector<number | undefined>({
  key: "productionUiIdSelector",
  get: ({ get }) => {
    return get(productionPollGroupStateAtom)?.productionUiId;
  },
});

export const productionUiStateSelector = selector<
  IProductionPollState | undefined
>({
  key: "productionUiStateSelector",
  get: ({ get }) => {
    const productionUiId = get(productionUiIdSelector);
    const states = get(productionPollStatesSelector);
    return states?.find(s => s.productionId === productionUiId);
  },
});

export const productionUiDisplayStateSelector =
  selector<IProductionDisplayState>({
    key: "productionUiDisplayStateSelector",
    get: ({ get }) => {
      const state = get(productionUiStateSelector);
      return getProductionDisplayStateFromPollState(state);
    },
  });

export const isProductionUiFirstSelector = selector<boolean>({
  key: "isProductionUiFirstSelector",
  get: ({ get }) => {
    const group = get(productionPollGroupStateAtom);
    return group?.productionUiId === group?.productionIds?.[0];
  },
});

export const productionUiChainSelector = selector<
  IProductionChainStep | undefined
>({
  key: "productionUiChainSelector",
  get: ({ get }) => {
    const productionUiId = get(productionUiIdSelector);
    const chains = get(productionPollChainsSelector);
    return chains.find(c => c.productionId === productionUiId);
  },
});
